/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  DataExportRoute,
  DataExportRoute$inboundSchema,
} from "./dataexportroute.js";

export type ListDataExportRoutesResult = {
  /**
   * Active data export routes in the selected project.
   */
  routes: Array<DataExportRoute>;
};

/** @internal */
export const ListDataExportRoutesResult$inboundSchema: z.ZodMiniType<
  ListDataExportRoutesResult,
  unknown
> = z.object({
  routes: z.array(DataExportRoute$inboundSchema),
});

export function listDataExportRoutesResultFromJSON(
  jsonString: string,
): SafeParseResult<ListDataExportRoutesResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListDataExportRoutesResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListDataExportRoutesResult' from JSON`,
  );
}
